import { StudentDto } from "../students/interfaces/student_dto";

export function groupStudentsByFirstLetter(
    students: StudentDto[]
  ): { letter: string; students: StudentDto[] }[] {
    const sections: { letter: string; students: StudentDto[] }[] = [];
    students.sort((a, b) => a?.forename?.localeCompare(b?.forename));

    students.forEach((student) => {
      const firstLetter = student?.forename?.substring(0, 1).toUpperCase();
      const sectionIndex = sections.findIndex(
        (section) => section.letter === firstLetter
      );

      if (sectionIndex === -1) {
        sections.push({ letter: firstLetter, students: [student] });
      } else {
        sections[sectionIndex].students.push(student);
      }
    });

    sections.sort((a, b) => a?.letter?.localeCompare(b?.letter));

    return sections;
  }